import { useState } from "react";
import { useAppContext } from "../../../context/AuthContext";
import { ArticleController, ArticleControllerType } from "../../../controller/article/ArticleController";
import { UserController, UserControllerType } from "../../../controller/user/UserController";
import Labels from "../../../lang/Labels_en";
import MessageType from "../../../utils/MessageType";
import { handleErrorMessage, useEffectOnce } from "../../../utils/Utils";

interface ReviewersStatisticsServiceType {
  value: any;
  handleChange: any;
  reviewerList: any;
  getReviewersStatisticsList: any;
  saveReviewer: any;
}

export default function ReviewersStatisticsService(): ReviewersStatisticsServiceType {
  const { showMessage, setBlockUI } = useAppContext();
  const { axiosGetReviewersStatistics }: ArticleControllerType = ArticleController();
  const { axiosSaveReviewer }: UserControllerType = UserController();

  const [reviewerList, setReviewerList] = useState<any>([]);

  const [value, setValue] = useState<any>({
    dateFrom: null,
    dateTo: null,
  });

  useEffectOnce(() => {
    getReviewersStatisticsList();
  });

  const getReviewersStatisticsList = () => {
    const params = {
      from: value.dateFrom,
      to: value.dateTo,
    };
    setBlockUI(true);
    axiosGetReviewersStatistics(params)
      .then((res: any) => {
        const parseData = res.data.map((item: any) => {
          const days = item.responseTime;
          return { ...item, responseTime: days ? parseFloat(days).toFixed(2) : "" };
        });
        setReviewerList(parseData);
        setBlockUI(false);
      })
      .catch((error: any) => {
        setBlockUI(false);
        handleErrorMessage(showMessage, error);
      });
  };

  const saveReviewer = (reviewer: any) => {
    axiosSaveReviewer(reviewer)
      .then((response: any) => {
        showMessage(Labels.SUCCESSFULLY_ADDED, MessageType.SUCCESS);
        getReviewersStatisticsList();
      })
      .catch((error: any) => {
        handleErrorMessage(showMessage, error);
      });
  };

  const handleChange = (e: any) => setValue({ ...value, [e.target.name]: e.target.value });

  return { value, handleChange, reviewerList, getReviewersStatisticsList, saveReviewer };
}

export type { ReviewersStatisticsServiceType };
